import * as React from 'react';

interface Props {
    children: React.ReactNode | Function;
}

export class LunchBreakOptions extends React.PureComponent<Props> {
    // eslint-disable-next-line class-methods-use-this
    get options(): Record<string, any> {
        return [
            {
                text: 'None',
                value: null
            },
            {
                text: '30',
                value: 30
            },
            {
                text: '60',
                value: 60
            }
        ];
    }

    render(): React.ReactElement {
        const { children } = this.props;

        if (typeof children === 'function') {
            // @ts-ignore
            return children(this.options);
        }

        // @ts-ignore
        return React.cloneElement(children, { options: this.options });
    }
}

export default LunchBreakOptions;
